var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomArrowWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 19,
    viewBox: "0 0 38 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_661_3435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5816 3.88231L29.26 5.56223L20.113 14.7123C19.9665 14.8598 19.7922 14.9769 19.6002 15.0567C19.4082 15.1366 19.2023 15.1777 18.9944 15.1777C18.7865 15.1777 18.5806 15.1366 18.3886 15.0567C18.1966 14.9769 18.0224 14.8598 17.8758 14.7123L8.72412 5.56223L10.4025 3.8839L18.992 12.4719L27.5816 3.88231Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_661_3435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 38,
    fill: "white",
    transform: "translate(38 1.66103e-06) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomArrowWhite);
export default __webpack_public_path__ + "static/media/bottom_arrow_white.a76c97f5c6f2a26c29f3cd3236fce32c.svg";
export { ForwardRef as ReactComponent };